var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMembershub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1122_32391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0005 21.2683C22.3161 21.2684 24.4329 21.929 25.729 22.991C27.0563 24.0786 27.4038 25.4861 27.4038 26.6707V27.4041H10.5962V26.6707C10.5962 25.5431 10.9483 24.1429 12.2661 23.0437C13.5597 21.9648 15.6763 21.2683 19.0005 21.2683Z",
    stroke: "white",
    strokeWidth: 1.4674
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.9333,
    cy: 14.9314,
    r: 3.6685,
    stroke: "white",
    strokeWidth: 1.4674
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_32391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.009,
    height: 18.009,
    fill: "white",
    transform: "translate(9.99548 9.99561)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMembershub);
export default __webpack_public_path__ + "static/media/Icon-Members hub.0af5030086feec67139316facad784ba.svg";
export { ForwardRef as ReactComponent };